import DynamicMap from './components/DynamicMap.js'
import Home from "./components/Home/Home.js"
import About from "./components/About/About.js"
import React, { useState } from "react";

export default function App() {
  const [page, setPage] = useState("Home");

  return (
    <div className="App">
      {page === "Home" ? (
        <Home onEnter={() => setPage("Map")} onAbout={() => setPage("About")} />
      ) : page === "Map" ? (
        <DynamicMap onHome={() => setPage("Home")} />
      ) : page === "About" ? (
        <About onHome={() => setPage("Home")} />
      ) : null}
    </div>
  );
}
